import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import appReducer from "./app/appReducer";
import configReducer from "./config/configReducer";
import authReducer from "./auth/authReducer";
import dataReducer from './data/dataReducer';
import userReducer from "./user/userReducer";
import pageReducer from "./page/pageReducer";
import reportReducer from "./report/reportReducer";
import persistReducer from "./persist/persistReducer";

// NOTE: If you need to persist see whitelist in store.js otherwise see examples
// for wrapping up the reducer and blacklisting what you do not want... configuration
// in store.js is the entire config
// https://blog.reactnativecoach.com/the-definitive-guide-to-redux-persist-84738167975

export default (history) =>
    combineReducers({
        router: connectRouter(history),
        app: appReducer,
        config: configReducer,
        auth: authReducer,
        data: dataReducer,
        user: userReducer,
        page: pageReducer,
        report: reportReducer,
        persist: persistReducer

        // ... rest of your reducers
    });
